import { Expression } from '../../data/text-or-code.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'
import { jsonClass, jsonProperty } from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { FormInputBlock } from './form-input-block.js'
import { PreviewType } from '../block'
import type { EventType } from '../../types'
import { Parameter } from '../../script/parameter.js'
import { BlockComponentImport } from '../block-component-import.js'

@jsonClass('PhoneInputBlock')
export class PhoneInputBlock extends FormInputBlock {
	declare labelCode?: TextOrExpression_assumeExpression

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: () => 'Binding',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: true,
		isMandatory: () => true,
	})
	bindingCode = new Expression()

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 3,
		label: () => 'Preferred countries',
		codeLanguage: 'ts',
		editorSize: 'singleline',
		tsReturnType: () => 'string[]',
		isBinding: false,
		isMandatory: () => false,
	})
	preferredCountries = new Expression()

	// @jsonProperty(Expression)
	// @ScreenEditorInput({
	// 	inputType: 'code',
	// 	order: 3,
	// 	label: () => 'Only countries',
	// 	codeLanguage: 'ts',
	// 	editorSize: 'singleline',
	// 	tsReturnType: () => 'string[]',
	// 	isBinding: false,
	// 	isMandatory: () => false,
	// })
	// onlyCountries = new Expression()

	@jsonProperty(Boolean)
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 4,
		label: () => 'Show country format',
	})
	showCountryFormat = false

	@jsonProperty(Boolean)
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 5,
		label: () => 'Disable search',
	})
	disableSearch = false

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 6,
		label: () => 'Default country',
		codeLanguage: 'ts',
		editorSize: 'singleline',
		tsReturnType: () => 'string',
		isBinding: false,
		isMandatory: () => false,
	})
	defaultCountry = new Expression()

	@jsonProperty(Boolean)
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 5,
		label: () => 'Hide area codes',
	})
	hideAreaCodes = false

	constructor() {
		super()
		this.validationRules = []
	}

	getEditorCategory(): string {
		return 'Additional Form Fields'
	}

	canHaveAppearance(): boolean {
		return true
	}

	producePreview(): PreviewType {
		return {
			type: 'icon',
			fontIcon: 'settings_phone',
			fontSet: 'material-icons',
		}
	}

	canHaveValidators() {
		return true
	}

	getValidationValueType(): string {
		return 'string'
	}

	get allowedEventTypes(): EventType[] {
		return [
			{
				name: 'countryChanged',
				parameters: [
					new Parameter({
						name: 'country',
						type: 'any',
						defaultExpression: '$event',
					}),
				],
			},
		]
	}
}
